import { createFileRoute } from "@tanstack/react-router"
import { HouseholdDetailPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/members/households/$householdUuid"
)({
  component: () => (
    <AuthorizationGate resource={Resource.MEMBERSHIP} action={Action.READ}>
      <HouseholdDetailPage />
    </AuthorizationGate>
  ),
})
